module.exports = __webpack_public_path__ + "img/avatar.d1317dd3.png";